import { Typography, styled, Link } from '@ori-ui/mui';

export const Root = styled(Link)(({ theme }) => ({
  background: theme.palette.primary.main,
  border: '2px solid',
  borderColor: theme.palette.primary.main,
  borderRadius: '999px', // TODO: ?
  boxSizing: 'border-box',
  color: theme.palette.background.paper,
  cursor: 'pointer',
  display: 'block',
  fontWeight: 'bold',
  height: 45,
  margin: theme.spacing(1),
  maxWidth: '100%',
  position: 'relative',
  textAlign: 'center',
  textDecoration: 'none',
  textTransform: 'uppercase',
  transition: 'box-shadow 0.15s, transform 0.15s',
  verticalAlign: 'middle',
  whiteSpace: 'nowrap',
  '&:hover': {
    boxShadow: '0 3px 8px 0 rgba(51, 51, 51, 0.1)',
    color: theme.palette.background.paper,
    transform: 'scale(1.01)', // TODO: ?
  },
}));

export const Label = styled(Typography)(({ theme }) => ({
  fontWeight: 'bold',
  lineHeight: `${theme.spacing(8)}`,
}));
